/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : COLOR PICKER --------------- ++++++++++ */
export default theme => ({
	colorpicker: {
		width: '100%',

		// .... CURRENT COLOR ..... //
		'& .currentcolor': {
			display: 'flex',
			alignItems: 'center',
			'& .swatch': {
				borderRadius: pxToEm(4),
				cursor: 'pointer',
				width: pxToEm(30),
				height: pxToEm(30),
				marginRight: pxToEm(3)
			},
			'& .colortext': {
				fontSize: pxToEm(16)
			},
			'& .field': {
				flex: '1',
				'& .formelement': {
					height: pxToEm(30)
				}
			}
		},

		// ..... COLOR PICKER ..... //
		'& .picker': {
			opacity: '0',
			position: 'absolute',
			left: '0',
			zIndex: '-1',
			transform: 'translateY(-200%)', // done so we don't have any clickable invisible hotspots on the page
			'&.active': {
				animationDuration: '.3s',
				animationFillMode: 'forwards',
				animationName: 'fadeInLeft',
				animationDelay: '0s',
				zIndex: '3'
			},
			'&.inactive':{
				display: 'none'
			},
			'& .name-close': {
				width: '100%'
			},
			'& .sketch-picker': {
				width: `${pxToEm(150)} !important`,
				borderRadius: '0 !important'
			}
		}
	},
});
